<template>
	<BaseTransactionModal :title="t('title')" :date="date">
		<template #content="{ close }">
			<SubtitleText>{{ t('opened') }}</SubtitleText>
			<BaseCard
				class="mt-2 flex items-center gap-4 py-2 pr-5 pl-2"
				alt
				v-hover="{ active: 'scale-95' }"
				@click="navigate(close)"
			>
				<ItemIcon
					:src="caseIcon(box.uuid, true)"
					:name="box.name"
					alt
					noBackdrop
				/>
				<div
					class="text-label-primary min-w-0 flex-1 truncate text-sm font-medium"
				>
					{{ box.name }}
				</div>
				<CoinPrice v-if="box.price" :price="box.price" />
				<EmptyIcon class="text-label-tertiary h-6 w-6" v-else />
			</BaseCard>
			<div class="mt-4 flex justify-between" v-if="item">
				<SubtitleText>{{ t('unboxed') }}</SubtitleText>
				<SubtitleText v-if="item.chance">{{ item.chance }}%</SubtitleText>
			</div>
			<BaseCard
				class="mt-2 flex items-center gap-4 py-2 pr-5 pl-2"
				alt
				v-if="item"
			>
				<ItemIcon
					:src="icon(item.modelUuid)"
					:name="`${item.collectionName} ${item.modelName}`"
					alt
					v-if="item.modelUuid"
				/>
				<div class="min-w-0 flex-1">
					<div class="text-label-secondary text-xs font-medium uppercase">
						{{ item.collectionName }}
					</div>
					<div class="text-label-primary mt-1 truncate text-sm font-medium">
						{{ item.modelName }}
					</div>
				</div>
				<CoinPrice :price="item.price" v-if="item.price" />
			</BaseCard>
		</template>
		<template #action="{ close }" v-if="fair">
			<BaseButton
				class="w-full"
				color="primary"
				size="lg"
				@click="openFairness(close)"
			>
				{{ t('verify') }}
			</BaseButton>
		</template>
	</BaseTransactionModal>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import BaseTransactionModal from './BaseTransactionModal.vue'
import SubtitleText from '@/components/SubtitleText.vue'
import BaseCard from '@/components/BaseCard.vue'
import { caseIcon, icon } from '@/utils/urls'
import CoinPrice from '@/components/CoinPrice.vue'
import BaseButton from '@/components/BaseButton.vue'
import ItemIcon from '@/components/ItemIcon.vue'
import EmptyIcon from '@/assets/icons/empty.svg'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const { t } = useI18n({
	messages: {
		en: {
			title: 'case opening',
			opened: 'case opened',
			verify: 'verify fairness',
			unboxed: 'loot unboxed'
		},
		ru: {
			title: 'открытие кейса',
			opened: 'открыт кейc',
			verify: 'проверить честность',
			unboxed: 'дроп кейса'
		}
	}
})

const props = defineProps<{
	date: Date
	box: {
		uuid: string
		name: string
		price?: number
		public?: boolean
	}
	item?: {
		modelUuid: string
		modelName: string
		collectionName: string
		price?: number
		chance?: number
	}
	fair?: unknown
}>()

const emit = defineEmits<{
	(e: 'openFairness'): void
}>()

const openFairness = (close: () => void) => {
	emit('openFairness')
	close()
}

const router = useRouter()

const navigate = (close: () => void) => {
	if (!props.box.public) {
		return
	}

	close()

	router.push(`/cases/${props.box.uuid}`)
}
</script>
